function highlightKeyword(container, keyword, tooltip) {
	const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null)
	const nodesToProcess = []
	
	while (walker.nextNode()) {
		nodesToProcess.push(walker.currentNode)
	}

	const regex = new RegExp(`\\b(${keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})\\b`, 'gi')

	nodesToProcess.forEach(textNode => {
		const text = textNode.textContent
		if (!regex.test(text)) return
		
		regex.lastIndex = 0
		const fragment = document.createDocumentFragment()
		let lastIndex = 0
		let match

		while ((match = regex.exec(text)) !== null) {
			if (match.index > lastIndex) {
				fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)))
			}

			const span = document.createElement('span')
			span.className = 'glossary-term'
			span.setAttribute('data-tooltip', tooltip)
			span.setAttribute('tabindex', '0')
			
			const em = document.createElement('em')
			em.textContent = match[1]
			span.appendChild(em)
			
			fragment.appendChild(span)
			lastIndex = regex.lastIndex
		}

		if (lastIndex < text.length) {
			fragment.appendChild(document.createTextNode(text.slice(lastIndex)))
		}

		textNode.parentNode.replaceChild(fragment, textNode)
	})
}

document.addEventListener('DOMContentLoaded', () => {
	// Process glossary terms
	const sections = document.querySelectorAll('.data-overview[data-glossary]')
	sections.forEach(section => {
		const glossaryData = section.getAttribute('data-glossary')
		if (!glossaryData) return

		try {
			const glossary = JSON.parse(glossaryData)
			if (!glossary || !glossary.length) return

			const textContainers = section.querySelectorAll('.before-card-copy, .card-copy, .after-card-copy')
			textContainers.forEach(container => {
				glossary.forEach(({ keyword, tooltip }) => {
					if (!keyword || !tooltip) return
					highlightKeyword(container, keyword, tooltip)
				})
			})
		} catch (e) {
			console.error('Failed to parse glossary data:', e)
		}
	})

	const infoButtons = document.querySelectorAll('.data-overview .info-button[data-popup-content]')
	
	if (infoButtons.length === 0) return

	// Create modal only once
	let modal = document.getElementById('data-overview-modal')
	if (!modal) {
		modal = document.createElement('div')
		modal.id = 'data-overview-modal'
		modal.className = 'data-overview-modal default-typography'
		modal.setAttribute('role', 'dialog')
		modal.setAttribute('aria-modal', 'true')
		modal.setAttribute('aria-hidden', 'true')
		modal.innerHTML = `
			<div class="modal-content" tabindex="-1">
				<button type="button" class="modal-close" aria-label="Close modal">&times;</button>
				<div class="modal-body"></div>
			</div>
		`
		document.body.appendChild(modal)
	}

	const modalWrapper = modal.querySelector('.modal-content')
	const modalContent = modal.querySelector('.modal-body')
	const closeBtn = modal.querySelector('.modal-close')
	const getScrollbarWidth = () => window.innerWidth - document.documentElement.clientWidth
	let triggerElement = null

	const getFocusableElements = () => {
		return modal.querySelectorAll(
			'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
		)
	}

	const openModal = (content) => {
		const scrollbarWidth = getScrollbarWidth()
		document.body.style.paddingRight = `${scrollbarWidth}px`	
		document.body.style.overflow = 'hidden'
		document.documentElement.style.overflow = 'hidden'
		modalContent.innerHTML = content
		modal.setAttribute('aria-hidden', 'false')
		modal.classList.add('active')
		setTimeout(() => modalWrapper.focus(), 250)
	}

	const closeModal = () => {
		modal.classList.remove('active')
		modal.setAttribute('aria-hidden', 'true')
		modal.addEventListener('transitionend', () => {
			if (!modal.classList.contains('active')) {
				document.body.style.overflow = ''
				document.body.style.paddingRight = ''
				document.documentElement.style.overflow = ''
			}
		}, { once: true })
		if (triggerElement) {
			triggerElement.focus()
			triggerElement = null
		}
	}

	infoButtons.forEach(button => {
		button.addEventListener('click', () => {
			const content = button.getAttribute('data-popup-content')
			if (content) {
				triggerElement = button
				openModal(content)
			}
		})
	})

	closeBtn.addEventListener('click', closeModal)

	modal.addEventListener('click', (e) => {
		if (e.target === modal) {
			closeModal()
		}
	})

	document.addEventListener('keydown', (e) => {
		if (!modal.classList.contains('active')) return

		if (e.key === 'Escape') {
			closeModal()
			return
		}

		if (e.key === 'Tab') {
			const focusable = getFocusableElements()
			if (focusable.length === 0) return

			const first = focusable[0]
			const last = focusable[focusable.length - 1]

			if (!modal.contains(document.activeElement)) {
				e.preventDefault()
				first.focus()
				return
			}

			if (e.shiftKey && document.activeElement === first) {
				e.preventDefault()
				last.focus()
			} else if (!e.shiftKey && document.activeElement === last) {
				e.preventDefault()
				first.focus()
			}
		}
	})
})
